import { queryPaymentOnBehalfTreaty, signPaymentOnBehalfTreaty } from "@/api/treaty/paymentOnBehalf";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    // 查询代付协议内容
    async queryPaymentOnBehalfTreaty(context, params) {
      console.log(params);
      const { data } = await queryPaymentOnBehalfTreaty(params);
      return data;
    },
    // 簽署代付协议内容
    async signPaymentOnBehalfTreaty(context, params) {
      console.log(params);
      const res = await signPaymentOnBehalfTreaty(params);
      return res;
    }
  }
};
